'use client';

import { createContext, useContext, type ReactNode } from 'react';
import { useIsHydrating } from '@/hooks/use-server-rendered-mount';

const ServerTimeZoneContext = createContext<string | null>(null);

/** The viewer's zone as the server knew it (its timezone cookie), or null. */
export function ServerTimeZoneProvider({
  timeZone,
  children,
}: {
  timeZone: string | null;
  children: ReactNode;
}) {
  return (
    <ServerTimeZoneContext.Provider value={timeZone}>
      {children}
    </ServerTimeZoneContext.Provider>
  );
}

/**
 * Zone for sidebar date groups ("Today", "Yesterday", dates). The server and
 * the hydrating render both use the cookie zone (UTC without one) so the
 * markup matches; later renders use the browser's own zone, which is normally
 * the same one, so nothing moves.
 */
export function useSidebarDateTimeZone(): string | undefined {
  const serverTimeZone = useContext(ServerTimeZoneContext);
  const hydrating = useIsHydrating();
  return hydrating ? (serverTimeZone ?? 'UTC') : undefined;
}
